import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

/**
 * Selects the `replenCarouselPurchaseHistory` A/B test offer (ILLUPH-131086) from Test & Target offers.
 * @param {Object} state - Redux state
 * @returns {Object} The offer object, or Empty.Object when the offer is absent (e.g., Adobe Target timeout).
 */
const replenCarouselPurchaseHistorySelector = createSelector(
    testTargetOffersSelector,
    offers => offers.replenCarouselPurchaseHistory || Empty.Object
);

export { replenCarouselPurchaseHistorySelector };
